import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { DocumentIcon, EyeIcon } from '@heroicons/react/24/outline';
import PDFViewer from './PDFViewer';

// Set up PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFThumbnail = ({ pdfUrl, title, description, onClick }) => {
  const [showViewer, setShowViewer] = useState(false);
  
  const onDocumentLoadSuccess = () => {
    // PDF loaded successfully
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF thumbnail:', error);
  };

  return (
    <>
      <div className="group bg-gray-800/50 backdrop-blur-sm rounded-2xl border border-gray-700/50 hover:border-primary-500/50 transition-all duration-300 hover:transform hover:-translate-y-2 overflow-hidden cursor-pointer min-h-[400px] flex flex-col" onClick={onClick || (() => setShowViewer(true))}>
        {/* PDF Thumbnail */}
        <div className="h-48 bg-gray-900/50 flex items-center justify-center overflow-hidden">
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={
              <div className="flex flex-col items-center text-gray-400">
                <DocumentIcon className="h-12 w-12 mb-3 text-primary-400" />
                <span className="text-sm font-medium">Loading PDF...</span>
              </div>
            }
          >
            <div className="relative w-full h-full flex items-center justify-center">
              <Page
                pageNumber={1}
                width={180}
                height={180}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                className="shadow-lg rounded-lg border border-gray-600 object-contain"
              />
              
              {/* Overlay with play button */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center rounded-lg">
                <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100">
                  <EyeIcon className="h-6 w-6 text-white drop-shadow-lg" />
                </div>
              </div>
            </div>
          </Document>
        </div>

        {/* Content */}
        <div className="p-6 flex-1 flex flex-col">
          <div className="flex items-center text-gray-400 text-sm mb-3">
            <DocumentIcon className="w-4 h-4 mr-2 text-primary-400" />
            <span className="font-medium">PDF Document</span>
          </div>
          <h3 className="text-xl font-bold text-white mb-3 group-hover:text-primary-400 transition-colors">
            {title}
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed mb-4">
            {description}
          </p>
          <div className="flex items-center justify-between mt-auto">
            <span className="flex items-center text-primary-400 text-sm font-medium transition-all duration-300 group-hover:translate-x-1">
              Click to read
              <EyeIcon className="ml-2 h-4 w-4" />
            </span>
            <div className="bg-primary-600/20 text-primary-400 px-2 py-1 rounded-full text-xs font-medium">
              PDF
            </div>
          </div>
        </div>
      </div>

      {/* PDF Viewer Modal */}
      {showViewer && (
        <PDFViewer
          pdfUrl={pdfUrl}
          onClose={() => setShowViewer(false)}
        />
      )}
    </>
  );
};

export default PDFThumbnail;
